var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPaperClip = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.662,
    height: 12.524,
    viewBox: "0 0 13.662 12.524",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.975,22.517l-.5-.5a2.346,2.346,0,0,0-3.318,0h0L2.763,28.41a1.659,1.659,0,0,0,0,2.346l.334.334a1.716,1.716,0,0,0,2.346,0l4.721-4.721a.285.285,0,1,0-.4-.409l-.007.007L5.04,30.687a1.128,1.128,0,0,1-1.541,0l-.334-.334a1.09,1.09,0,0,1,0-1.541h0L9.56,22.419a1.822,1.822,0,0,1,2.513,0l.5.5a1.777,1.777,0,0,1,0,2.513l-7.13,7.13a2.464,2.464,0,0,1-3.484,0L1.291,31.9a2.464,2.464,0,0,1,0-3.484l5.457-5.457a.285.285,0,0,0-.4-.409l-.007.007L.889,28.008a3.033,3.033,0,0,0,0,4.289h0l.667.667a3.033,3.033,0,0,0,4.289,0h0l7.13-7.13a2.346,2.346,0,0,0,0-3.318Z",
    transform: "translate(0 -21.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.7,33.853a3.017,3.017,0,0,1-2.145-.889L.888,32.3a3.033,3.033,0,0,1,0-4.289h0l5.457-5.457a.285.285,0,1,1,.409.4l-.007.007L1.291,28.41a2.464,2.464,0,0,0,0,3.484l.667.667a2.464,2.464,0,0,0,3.484,0l7.13-7.13a1.777,1.777,0,0,0,0-2.513l-.5-.5a1.822,1.822,0,0,0-2.513,0L3.165,28.813a1.09,1.09,0,0,0,0,1.541h0l.334.334a1.128,1.128,0,0,0,1.541,0l4.721-4.721a.285.285,0,0,1,.409.4l-.007.007L5.442,31.09a1.716,1.716,0,0,1-2.346,0l-.334-.334a1.659,1.659,0,0,1,0-2.346l6.394-6.394a2.346,2.346,0,0,1,3.318,0h0l.5.5a2.346,2.346,0,0,1,0,3.318h0l-7.13,7.13A3.017,3.017,0,0,1,3.7,33.853Z",
    transform: "translate(0 -21.329)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaperClip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/paper-clip.988065d1.svg";
export { ForwardRef as ReactComponent };